import { ListChart, ListChartProps } from '../../../../renderers/list-chart/list-chart.component';
import { NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION } from './nivaliz-outbound-transaction-volume-by-state-list-chart.definition';
import { NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA } from './nivaliz-outbound-transaction-volume-by-state-list-chart.mock';

export const NivalizOutboundTransactionVolumeByStateListChart = (props: ListChartProps) => <ListChart {...props} />;

NivalizOutboundTransactionVolumeByStateListChart.definition = NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION;
NivalizOutboundTransactionVolumeByStateListChart.mockData = NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA;
